import { useQuery } from './useQuery';

export default () => {
  return useQuery().get('isNew') === 'true' || false;
};
